var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6077 4.18513L36.3005 13.6483C36.9404 14.9656 38.6469 16.2292 40.0867 16.4711L48.5925 17.896C54.0319 18.8101 55.3117 22.7889 51.3922 26.714L44.7796 33.3812C43.6597 34.5103 43.0464 36.688 43.393 38.2472L45.2862 46.5006C46.7793 53.0335 43.3397 55.5606 37.607 52.1463L29.6346 47.3878C28.1947 46.5275 25.8217 46.5275 24.3552 47.3878L16.3827 52.1463C10.6767 55.5606 7.21038 53.0066 8.70355 46.5006L10.5967 38.2472C10.9433 36.688 10.33 34.5103 9.21016 33.3812L2.59755 26.714C-1.29535 22.7889 -0.042153 18.8101 5.39724 17.896L13.903 16.4711C15.3161 16.2292 17.0226 14.9656 17.6626 13.6483L22.3554 4.18513C24.9151 -0.94973 29.0746 -0.94973 31.6077 4.18513Z",
    fill: "url(#paint0_linear_2075_2138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2075_2138",
    x1: -19.7905,
    y1: -5.67587,
    x2: 26.7245,
    y2: 49.6248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BE56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigYellowStar);
export default __webpack_public_path__ + "static/media/big-yellow-star.b4dfcd7e7f9001cd3acaa9709b7c8a60.svg";
export { ForwardRef as ReactComponent };